import styled from 'styled-components'
// import { FadeInFrame } from '../../styles/keyframes'

export const StyledPopupWrapper = styled.div`
position: relative;
margin:2rem;
display:flex;
justify-content: center;
text-align:center;
max-width: 1024px;

@media(orientation: portrait) {
  width: 98%;
}
`

export const StyledPopups = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;

  @media (orientation: portrait) {
    flex-direction: column;
    align-items: center;
  }
  
  button {
    span {
    color: black;
    text-align: center;
    }
  }
`
export const StyledPopupContent = styled.div`
box-shadow: ${({ theme }) => theme.boxShadows?.card2 || ''};
transition: all 0.3s linear;
transform: ${({ isPoppedUp }) => isPoppedUp ? 'scale(1)' : 'scale(0)'};
transform-origin: top ${({ position }) => position || '0'};
@media (orientation: portrait) {
  transform-origin: top center;
}
position: absolute;
z-index: 100000;
padding: 2rem;
max-width: 1024px;
@media (orientation: portrait) {
  max-width: 98%;
}
width: ${({ width }) => width || '30rem'};

${({ position }) => position}: 0;
background: white;
border-radius: ${({ theme }) => theme.chatBubble?.borderRadius || 'none'};
display:flex;
flex-direction:column;
> * {
  margin-top:1rem;
}
span {
  font-weight: 300;
  text-align: left;
  font-size: 1.2em;
  color: black;
  line-height: 1.2;
}
.news-article {
  font-family: 'New Times Roman'
}

li {
  list-style-position: outside;
  line-height: 1.5;
  color: black;
}
ul > li {
  list-style-position: outside;
  line-height: 1.5;
  color: black;
}


button {
  font-size: 1em;
}
`
export const StyledPopupContentHeader = styled.div`
  display:flex;
  justify-content:center;
  position:relative;
  font-size: 1.5em;
  button {
    position:absolute;
    right: -0.5rem;
    top: -1.5rem;
    
    div {
      background:  black;
    }
  }
`

export const StyledPopupButton = styled.button`
width: fit-content;
@media (orientation: portrait) {
  width: 100%;
  }
padding: 2rem 5rem;
cursor: pointer;
border-radius: 1rem;
box-shadow: ${({ theme }) => theme.boxShadows?.card1 || ''};
display: flex;
flex-direction: column;
font-size: 1.2em;
align-items: center;
background: #fdfdfd;
/*visibility: ${({ isPoppedUp }) => isPoppedUp ? 'hidden' : 'initial'};*/
transition: all 0.3s linear;
&:hover {
  filter: brightness(0.9)
}
span {
  margin-top: 1rem;
  font-size: 1.2em;
}
svg {
  max-height:5rem;
  min-height: 5rem;

  path {
    fill: #111;
  }
}
`
